<template>
  <div class="modal-body-itens-pedidos-consumidor">
    <div
      class="itens-pedidos-consumidor-container animate__animated animate__bounceInDown animate__delay-0.5s"
    >
      <div class="itens-pedidos-consumidor-container01">
        <div class="itens-pedidos-consumidor-title">
          <h3>Itens do Pedido - Consumidor</h3>
        </div>
        <div class="itens-pedidos-consumidor-close">
          <CloseIcon @action="closeModal" />
        </div>
      </div>
      <div class="itens-pedidos-consumidor-container02">
        <div
          class="itens-pedidos-consumidor-container03"
          v-if="
            $marketplace_consumidor.itens_pedido &&
            $marketplace_consumidor.itens_pedido.length == 0 &&
            !$marketplace_consumidor.loading_itens_pedido
          "
        >
          <span>Não há registro de itens para este pedido.</span>
        </div>
        <v-progress-linear
          indeterminate
          v-else-if="$marketplace_consumidor.loading_itens_pedido"
          color="#393939"
        ></v-progress-linear>
        <v-data-table
          class="itens-pedidos-consumidor-container03"
          :headers="headers"
          :items="tableValues"
          v-else
          :items-per-page="10"
          :footer-props="{
            itemsPerPageOptions: [10],
            itemsPerPageText: 'Itens por página:',
          }"
        >
          <template v-slot:item.actions="{ item }" class="table-actions">
            <div style="display: flex; justify-content: center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="$config.dados.corinputs"
                    height="30"
                    width="30"
                    small
                    icon
                    v-bind="attrs"
                    :disabled="item.status != 'Pago'"
                    v-on="on"
                    @click="
                      $marketplace_consumidor.imprimirIngresso(
                        item.iditem,
                        item.sequenciador
                      )
                    "
                  >
                    <v-icon>mdi-printer-outline</v-icon>
                  </v-btn>
                </template>
                <span>Imprimir</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalItensPedidoConsumidor",
  components: {
    CloseIcon: () => import("@/components/icons/CloseIcon.vue"),
  },
  data() {
    return {
      headers: [
        {
          text: "Localizador",
          align: "center",
          sortable: true,
          value: "localizador",
        },
        {
          text: "Descrição do Item",
          align: "center",
          sortable: true,
          value: "dsc_produto",
        },
        {
          text: "SKU",
          align: "center",
          sortable: true,
          value: "sku",
        },
        {
          text: "Status",
          align: "center",
          sortable: true,
          value: "status",
        },
        {
          text: "Data da Reserva",
          align: "center",
          sortable: true,
          value: "dthr_reserva",
        },
        {
          text: "Data de Pagamento",
          align: "center",
          sortable: true,
          value: "dthr_pagamento",
        },
        {
          text: "Valor",
          align: "center",
          sortable: false,
          value: "valor",
        },
        {
          text: "Valor Juros",
          align: "center",
          sortable: false,
          value: "valor_juros",
        },
        {
          text: "Valor Desconto",
          align: "center",
          sortable: false,
          value: "valor_desconto",
        },
        {
          text: "Valor Total",
          align: "center",
          sortable: false,
          value: "valor_total",
        },
        {
          text: "Ações",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],
    };
  },
  computed: {
    tableValues() {
      this.$marketplace_consumidor.itens_pedido.forEach(item => {
        item.localizador = item.localizador ? item.localizador : "-";
        item.sku = item.sku ? item.sku : "-";
        item.status = item.status ? item.status : "-";
        item.dthr_pagamento = item.dthr_pagamento
          ? this.$config.convertDataBR(item.dthr_pagamento.substring(0, 10))
          : "-";
        item.dthr_reserva = item.dthr_reserva
          ? this.$config.convertDataBR(item.dthr_reserva.substring(0, 10))
          : "-";
        item.valor = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        }).format(Number.parseFloat(item.valor));
        item.valor_juros = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        }).format(Number.parseFloat(item.valor_juros));
        item.valor_desconto = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        }).format(Number.parseFloat(item.valor_desconto));
        item.valor_total = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        }).format(Number.parseFloat(item.valor_total));
      });
      return this.$marketplace_consumidor.itens_pedido;
    },
  },
  methods: {
    closeModal() {
      this.$marketplace_consumidor.itens_pedido = [];
      document.getElementsByClassName(
        "modal-body-itens-pedidos-consumidor"
      )[0].style.display = "none";
    },
  },
};
</script>

<style scoped>
.modal-body-itens-pedidos-consumidor {
  display: none;
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  /* overflow: auto; */
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
  justify-content: center;
  align-items: center;
}

.itens-pedidos-consumidor-container {
  width: 95%;
  min-width: 1300px;
  height: auto;
  max-height: 800px;
  display: flex;
  z-index: 100;
  position: relative;
  box-shadow: 1px 1px 30px 3px #000000;
  align-items: center;
  border-radius: 1.25rem;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #eaeaea;
}

.itens-pedidos-consumidor-container01 {
  flex: 0 0 auto;
  width: 100%;
  height: 5%;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: flex-end;
  padding-top: 0.5rem;
  padding-right: 0.5rem;
}

.itens-pedidos-consumidor-title {
  width: 97%;
  display: flex;
  justify-content: center;
}

.itens-pedidos-consumidor-close {
  width: 3%;
  display: flex;
  justify-content: flex-end;
}

.itens-pedidos-consumidor-icon {
  width: 24px;
  height: 24px;
  margin-top: 3px;
  margin-right: 6px;

  transition: all 0.2s ease;
}

.itens-pedidos-consumidor-icon:hover {
  fill: #fff;
  cursor: pointer;
}

.itens-pedidos-consumidor-container02:hover {
  cursor: pointer;
}

.itens-pedidos-consumidor-container02 {
  flex: 0 0 auto;
  width: 100%;
  height: auto;
  max-height: 95%;
  display: flex;
  align-items: center;
  padding: 1.25rem;
  flex-direction: column;
  justify-content: center;
}

.itens-pedidos-consumidor-container03 {
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 1.25rem;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #fff;
  overflow-y: auto;
}

@media (max-width: 1366px) {
  .itens-pedidos-consumidor-container {
    width: 98%;
    min-width: 1000px;
    height: auto;
    max-height: 95%;
  }
}
</style>
